import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

const chatBubbleUrl =
  "https://6be7e0906f1487fecf0b9cbd301defd6.cdn.bubble.io/f1729894095742x981944481074606300/chat-round-svgrepo-com.svg";
const chatWidgetUrl =
  "https://youraiagent.com/chat-widget-new/1745253563561x782890720097468400";
const chatBoxBottom = 90;
const chatBoxTopDifference = chatBoxBottom + 10;
const mobileMaxWidth = 991;
const desktopMinWidth = 992;
const Backdrop = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  opacity: 0;
  transition: opacity 0.3s ease;

  &.show {
    display: block;
    opacity: 1;
  }

  @media (min-width: ${desktopMinWidth}px) {
    display: none !important;
  }
`;

const ChatBubble = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #86cf59;
  border-radius: 50%;
  cursor: pointer;
  z-index: 9999;
  transition: transform 0.3s ease, bottom 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    transition: transform 0.3s ease;
  }

  @media (max-width: ${mobileMaxWidth}px) {
    bottom: ${(props) => (props.isVisible ? "20px" : "50px")};
  }
`;

const ChatWidgetContainer = styled.div`
  display: none;
  position: fixed;
  bottom: ${chatBoxBottom}px;
  right: 20px;
  width: 500px;
  max-width: 90%;
  height: calc(100vh - ${chatBoxTopDifference}px);
  height: calc(var(--vh, 1vh) * 100 - ${chatBoxTopDifference}px);
  min-height: 400px;
  z-index: 9999;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  overflow: hidden;
  transition: opacity 0.3s ease;
  opacity: 0;
  flex-direction: column;

  &.show {
    display: flex;
    opacity: 1;
  }
`;

const ChatHeader = styled.div`
  background-color: #8f62ff;
  color: #fff;
  padding: 15px;
  font-weight: bold;
  text-align: center;
  flex-shrink: 0;
`;

const ChatContent = styled.div`
  flex-grow: 1;
  display: block;
`;

const Backlink = styled.div`
  position: absolute;
  bottom: -30px;
`;

const ChatWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [vh, setVh] = useState(undefined);
  const [isMobile, setIsMobile] = useState(window.innerWidth < desktopMinWidth);
  const iframeRef = useRef(null);
  const chatWidgetContainerRef = useRef(null);

  const toggleChat = () => {
    setIsVisible(!isVisible);
  };

  // Load the chat widget when the component is mounted and the chat is opened
  useEffect(() => {
    if (!isIframeLoaded && isVisible) {
      iframeRef.current.src = chatWidgetUrl;
    }
  }, [isVisible, iframeRef, isIframeLoaded]);

  // Create a resize listener to update the vh variable and set the isMobile state
  // this custom vh is a substitute for css vh that is more reliable for mobile devices
  useEffect(() => {
    const resizeListener = () => {
      setVh((window.innerHeight * 0.01).toFixed(2));
      setIsMobile(window.innerWidth < desktopMinWidth);
    };
    window.addEventListener("resize", resizeListener);
    resizeListener();
    return () => window.removeEventListener("resize", resizeListener);
  }, []);

  // Update the custom vh variable when the vh variable changes
  useEffect(() => {
    if (vh) {
      chatWidgetContainerRef.current.style.setProperty("--vh", `${vh}px`);
    }
  }, [vh]);

  // Prevent scroll when the chat is open on mobile devices
  useEffect(() => {
    document.body.style.overflow = isVisible && isMobile ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isVisible, isMobile]);

  return (
    <>
      <Backdrop
        className={isVisible ? "show" : ""}
        onClick={() => setIsVisible(false)}
      />
      <ChatBubble onClick={toggleChat} isVisible={isVisible}>
        <img src={chatBubbleUrl} alt="Chat" />
      </ChatBubble>
      <ChatWidgetContainer
        ref={chatWidgetContainerRef}
        className={isVisible ? "show" : ""}
      >
        <ChatHeader>Special Insurance by GBLI (NYSE: GBLI)</ChatHeader>
        <ChatContent>
          <iframe
            ref={iframeRef}
            id="chat-widget-iframe"
            style={{ border: "none", width: "100%", height: "100%" }}
            title="AI Chat Widget"
            onLoad={() => setIsIframeLoaded(true)}
          />
        </ChatContent>
        <Backlink>
          <a href="https://eventsguardian.com">Powered by eventsguardian.com</a>
        </Backlink>
      </ChatWidgetContainer>
    </>
  );
};

export default ChatWidget;
